{
  "header": "एसेट विवरण",
  "subtitle": "आपके ट्रक से जुड़ा एसेट (ट्रेलर, कंटेनर आदि)।",
  "assetType": "एसेट प्रकार",
  "assetTypePlaceholder": "एसेट प्रकार चुनें",
  "assetId": "एसेट आईडी (उदा. ट्रेलर नंबर)",
  "assetIdPlaceholder": "उदा.: ट्रेलर नंबर, कंटेनर आईडी आदि",
  "remove": "हटाएं",
  "addAnother": "एक और एसेट जोड़ें",
  "trailerType": "ट्रेलर प्रकार",
  "trailerId": "ट्रेलर आईडी"
}
